import { UserType } from '@/api/resources/common/initialization/common-initialization.dto'
import { EnumTranslatedResponse } from '@/api/services/common.dto'
import i18n from '@/lang/i18n'

export enum OperationTypeEnum {
    READ = 'READ',
    CREATE = 'CREATE',
    EDIT = 'EDIT',
    DELETE = 'DELETE',
    PRINT = 'PRINT',
    ATTACH = 'ATTACH',
    ACCESS = 'ACCESS',
    TASK = 'TASK'
}

export enum OperationGroupEnum {
    SAMPLE = 'operation.entity.sample',
    PORTION = 'operation.entity.portion',
    SUBPORTION = 'operation.entity.subportion'
}

interface OperationGroupEntity {
    [key: string]: string
}

export const OperationGroupEntities: OperationGroupEntity = {
    [OperationGroupEnum.SAMPLE]: i18n.tc('entities.coreEntities.sample'),
    [OperationGroupEnum.PORTION]: i18n.tc('entities.coreEntities.portion'),
    [OperationGroupEnum.SUBPORTION]: i18n.tc('entities.coreEntities.subportion')
}

export interface OperationResponse {
    code: string
    global: boolean
    group: OperationGroupEnum
    id: number
    userType: EnumTranslatedResponse<UserType>
    translatedName: string
    type: OperationTypeEnum
}
